
import * as Models from "../ts/rlAdmin.models";
import * as Utils from "../ts/rlAdmin.utils";
import * as Consts from "../ts/rlAdmin.consts";


import { RLSidepanelPreviewsController } from "./sidepanel-previews"
// -------- rl-sidepanel-preview-item ---------------------------------------------

export interface IRLSidepanelPreviewItemScope extends ng.IScope {
	sidepanelPreviewsController: RLSidepanelPreviewsController;
	entity: any;
	title: string;
}

export function RLSidepanelPreviewItem(): ng.IDirective {
	return {
		restrict: 'EA',
		template: require("/assets/app/templates/sidepanel-preview-item.html"),
		bindToController: {
			entity: "=",
			title: "=?"
		},
		scope: true,
		controller: RLSidepanelPreviewItemController,
		controllerAs: 'previewVM',
		transclude: true,
		require: ["rlSidepanelPreviewItem", "^rlSidepanelPreviews"],
		link: (scope: IRLSidepanelPreviewItemScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controllers: any[]) => {

			var previewItemController: RLSidepanelPreviewItemController = controllers[0];
			var previewsController: RLSidepanelPreviewsController = controllers[1];

			previewItemController.AutoSetTitle();
			previewItemController.sidepanelPreviewsController = previewsController;

			previewsController.RegisterElementForEntity(previewItemController);

			return;
		}
	}
}

export class RLSidepanelPreviewItemController {
	static $inject = ["$window", "$scope", "$rootScope", "$element", "$timeout"];

	public entity: any;
	public sidepanelPreviewsController: RLSidepanelPreviewsController;
	public collapsablePanelSelector: string = ".rl-panel-content";

	public title: string;

	public element: ng.IAugmentedJQuery;

	private isCollapsed: boolean;

	constructor(
		private $window: ng.IWindowService,
		private $scope: IRLSidepanelPreviewItemScope,
		private $rootScope: ng.IRootScopeService,
		private $element: ng.IAugmentedJQuery,
		private $timeout: ng.ITimeoutService) {

		this.element = $element;

		this.isCollapsed = true;

		this.Init();

		$scope.$on(Consts.Events.RefreshPreviewEntity, (event, entity: Models.IUsageRelationshipPair) => {
			if (entity != undefined) {
				if (this.entity && this.entity.record.id == entity.record.id) {
					this.entity = entity;
				}
			}            
		});
	}

	public get IsCollapsed(): boolean {
		return this.isCollapsed;
	}

	private get CollapsableElement(): JQuery {
		return this.element.find(this.collapsablePanelSelector);
	}

	private get ParentScroller(): JQuery {
		var ret: JQuery = this.element.closest(".col-secondary");
		return ret;
	}

	Init() {
		return;
	}

	public AutoSetTitle() {
		if (!this.title) {
			if (this.entity.record.charTypeID == 7) {
				this.title = this.entity.record.template + " " + this.entity.record.recordID;
			}
			else {
				this.title = (this.entity != null && this.entity.record != null && this.entity.record.title != null) ? this.title = this.entity.record.title : "Preview";
			}
		}
		return;
	}

	public ScrollIntoView(duration: number, complete?: Function) {

		if (!this.ParentScroller) {
			return;
		}

		var parentScrollerOffset = this.ParentScroller.offset();

		if (!parentScrollerOffset) {
			return;
		}

		var scrollableDivTop = parentScrollerOffset.top;
		var scrollableDivScrollTop = this.ParentScroller.scrollTop();
		var targetDivTop = this.element.offset().top;
		var scrollTopVal: number = (targetDivTop - scrollableDivTop - 8) + scrollableDivScrollTop;

		this.ParentScroller.animate({ scrollTop: scrollTopVal }, duration, <(this: HTMLElement) => void>complete);

		return;
	}

	public Collapse() {
		this.isCollapsed = true;
		this.CollapsableElement.slideUp();
	}

	public AutoHide() {
		this.isCollapsed = true;
		this.$timeout(() => {
			this.CollapsableElement.hide();
		});
	}

	public ShowInitialAnimations() {

		var savedTransition = this.element.css("transition");

		this.element.css("transition", "none");
		this.element.addClass("initial");

		this.$timeout(() => {
			this.element.css("transition", savedTransition);
			this.element.removeClass("initial");
		}, 80);

		return;
	}

	public Expand() {
		this.isCollapsed = false;
		this.$rootScope.$broadcast(Consts.Events.RefreshViewEntity, this.entity.attachmentID != undefined ? this.entity.attachmentID : this.entity.record.id);
		this.CollapsableElement.slideDown();
	}

	public TestIsCollapsed(): boolean {
		this.isCollapsed = !this.CollapsableElement.is(":visible");
		return;
	}

	public ToggleExpanded() {		
		this.sidepanelPreviewsController.CollapseAllBut(this.entity);
        this.isCollapsed = this.CollapsableElement.is(":visible");
        if (this.isCollapsed) {
            this.$rootScope.$broadcast(Consts.Events.RefreshViewEntity, "");
        }
        else {
            this.$rootScope.$broadcast(Consts.Events.RefreshViewEntity, this.entity.attachmentID != undefined ? this.entity.attachmentID : this.entity.record.id);
        }
		this.CollapsableElement.slideToggle();
	}

    public Close() {
        if (!this.isCollapsed) {
            this.$rootScope.$broadcast(Consts.Events.RefreshViewEntity, "");		
        }
		this.sidepanelPreviewsController.ClosePreview(this.entity);
	}
}
